/**
* Data model that represents a set of selected resources for iCal integration
*
* @class ResourceSetModel
*/
var ResourceSetModel = function ( data ) {
	var self; // Convenience reference so the context of 'this' becomes clearer

	// Predicate this data model on the AbstractDataModel.
	// This establishes core functionality required of DataModels,
	// which can be overwritten by methods below.
	// Specifically, conversion of XML data to JSON
	AbstractDataModel.apply( this, arguments );

	self = this;

	self.id				= null;
	self.description	= null;
	self.name			= null;
	self.resources		= [];
	self.selectionId	= null;




	/**
	* If the model was initialized with a data parameter, populate the observed variables.
	*/
	if ( data ) {

		for ( var prop in data ) {
			if ( data.hasOwnProperty( prop ) ) {
				self[prop] = data[prop];
			}
		}

		self.id = self.selectionId;
	}

	// Return self (ResourceSetModel) to be chainable, for best practice
	return self;
};

ResourceSetModel.prototype = AbstractDataModel.prototype;
ResourceSetModel.prototype.constructor = ResourceSetModel;